/**
 * TanStack Query client configuration
 */

import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "@components/hot-toast";
import Toast from "@components/notifications/Toast";

const MAX_RETRIES = 3;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`Query error for '${query.queryKey}': `, error);
      toast.custom((t) => <Toast type="error" body={error?.message || "An error occurred"} t={t} />);
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        console.error(`Retrying query (N=${failureCount}): `, error);
        return failureCount < MAX_RETRIES;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
    mutations: {
      onError: (error) => {
        console.error("Mutation error: ", error);
        const message = error instanceof Error ? error.message : String(error);
        toast.custom((t) => <Toast type="error" body={message} t={t} />);
      },
    },
  },
});
